import { useSelector } from "react-redux"
import { RootState } from "../redux/store"

export const useIsUserLoggedin = () => {
  const { userData } = useSelector((state: RootState) => state.auth)
  return userData
}
